import type { FC } from "react";
import { Link } from "expo-router";
import { Button, Card, HowareuLogo } from "@ptsd/uikit";
import { useTranslation } from "react-i18next";
import { Text, XStack, YStack } from "tamagui";

import { OverviewCard } from "./overview-common";

export const OverviewHowareu: FC = () => {
  const { t } = useTranslation("overview");

  return (
    <OverviewCard
      title={t("howareu.title")}
      subtitle={
        <XStack alignItems={"flex-start"} justifyContent={"center"} gap={"$1"}>
          <HowareuLogo />
          <Text
            fontFamily={"$howareu"}
            lineHeight={"$6.5"}
            textAlign={"left"}
            fontWeight={"400"}
            fontSize={30}
          >
            {t("howareu.subtitle")}
          </Text>
        </XStack>
      }
    >
      <Card
        shadow="md"
        alignItems="center"
        paddingVertical={"$4"}
        paddingHorizontal={"$5"}
        borderColor={"$gray-600"}
        backgroundColor={"$warm-snow-500"}
      >
        <XStack gap={"$2"} alignItems="center" justifyContent="space-between">
          <YStack gap={"$1"} flex={1}>
            <Text
              fontFamily={"$body"}
              fontWeight={"$6"}
              fontSize={"$6"}
              lineHeight={"$5"}
              color={"$gray-900"}
            >
              {t("howareu.card.title")}
            </Text>
            <Text
              fontFamily={"$body"}
              fontWeight={"$5"}
              fontSize={"$4"}
              lineHeight={22}
              color={"$gray-900"}
            >
              {t("howareu.card.desc")}
            </Text>
          </YStack>
          <Link
            target="_blank"
            href={t("howareu.card.link")}
            rel="noopener noreferrer"
          >
            <Button
              size="md"
              variant="outlined"
              color="primary"
              rounded="md"
              minWidth={220}
            >
              {t("howareu.card.button")}
            </Button>
          </Link>
        </XStack>
      </Card>
    </OverviewCard>
  );
};
